// Import model
import { PromptCondition } from '../models/PromptCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { PromptIndexedFields } from '../models/PromptIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { PromptIndexedFieldsSerializer } from './PromptIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for PromptCondition - handles JSON serialization and deserialization with type validation
 */
export class PromptConditionSerializer {
  /**
   * Deserializes a JSON string into a PromptCondition instance
   */
  static deserialize(json: string): PromptCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a PromptCondition instance
   */
  static fromObject(obj: any): PromptCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to PromptCondition');
    }


    const instance: PromptCondition = {
      fieldName: obj['fieldName'] as PromptIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of PromptCondition instances
   */
  static deserializeArray(json: string): PromptCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a PromptCondition instance to a JSON string
   */
  static serialize(instance: PromptCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a PromptCondition instance to a plain object
   */
  static toObject(instance: PromptCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of PromptCondition instances to a JSON string
   */
  static serializeArray(instances: PromptCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
